import template from './financeList.html';
import { FinanceListController } from './financeList.controller';

export const financeListComponent = {
  restrict: 'E',
  template,
  controller: FinanceListController,
  controllerAs: 'vm',
  bindings: {
    finances: '<',
    filter: '<',
    filterValue: '<',
    editor: '=',
    editable: '<',
    removable: '<',
    title: '@',
    heading: '@',
    propertyTitle: '@',
    properties: '<',
    onChange: '&',
    onAdd: '&',
    onEdit: '&',
    onRemove: '&',
    onReset: '&',
    onSave: '&'
  }
};
